import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	components: {
	},
})
export default class InputPortal extends Vue {
	@Prop({ default: '' }) readonly text;
	@Prop({ default: false }) readonly show;
	@Prop() readonly errorList;

	get showError() {
		return this.show || this.findErrorShown();
	}

	findErrorShown() {
		if (this.errorList && this.errorList.length) {
			return this.errorList.find((error) => {
				return error.show;
			});
		}

		return false;
	}
}
